'use client';

import { BookOpenText, ChevronRight, X } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';

import Accordion from '../common/Accordion';
import IconButton from '../common/IconButton';

export default function Menu({ menu }: { menu: any }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();
  const [currentGroup, setCurrentGroup] = useState(
    menu?.find((tp: any) => pathname.startsWith(`/docs/${tp.slug}`))?.slug
  );

  return (
    <div className="fixed bottom-24 left-8 z-50 flex lg:static lg:z-0 lg:min-w-80">
      <div
        className={`rounded-md border bg-white transition-all lg:min-w-80 lg:border-none ${
          menuOpen
            ? 'fixed inset-0 h-screen w-screen overflow-auto p-5 shadow-lg lg:h-auto lg:shadow-none'
            : 'm-0 size-0 overflow-hidden border-none p-0 lg:block lg:size-auto lg:overflow-auto lg:p-5'
        }`}
      >
        <ul>
          {menu?.map((tp: any) => (
            <li key={tp.slug}>
              <Accordion
                label={tp.title}
                open={currentGroup === tp.slug}
                setOpen={() => setCurrentGroup(tp.slug)}
                className="mb-1"
              >
                <ul className="py-2">
                  {tp.questions.map((q: any) => (
                    <li key={q.slug}>
                      <Link
                        href={`/docs/${tp.slug}/${q.slug}/`}
                        className={`group mb-1 flex items-center gap-2 rounded-md py-2 pl-5 pr-3 transition-all duration-200 hover:bg-gray-50 ${
                          pathname.startsWith(`/docs/${tp.slug}/${q.slug}`)
                            ? 'bg-primary-100 font-medium text-primary-500'
                            : 'text-gray-950'
                        }`}
                      >
                        <ChevronRight
                          size={14}
                          className={`my-2 shrink-0 self-start opacity-0 transition-opacity ${
                            pathname.startsWith(`/docs/${tp.slug}/${q.slug}`)
                              ? 'text-primary-500 opacity-100'
                              : 'group-hover:opacity-50'
                          }`}
                        />
                        <span className="line-clamp-2">{q.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </Accordion>
            </li>
          ))}
        </ul>
      </div>
      <IconButton
        icon={menuOpen ? <X /> : <BookOpenText />}
        className="circle-button-shinny fixed bottom-60 right-2 z-50 box-border flex size-12 self-end rounded-full !px-0 transition-all duration-500 md:right-5 lg:hidden"
        type="button"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Open menu"
      />
    </div>
  );
}
